import { useEffect, useState } from 'react';
import HeroShader from './HeroShader';

const SLIDE_INTERVAL = 5000;

interface HeroSlide {
  key: string;
  title: string;
  image?: string;
}

const HERO_SLIDES: HeroSlide[] = [
  { key: 'brand', title: '数智华辉' },
  {
    key: 'agriculture',
    title: '智慧农业',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20aerial%20view%20of%20a%20modern%20smart%20agriculture%20greenhouse%20and%20lush%20farmland%20at%20blue%20hour%2C%20tall%20IoT%20sensor%20poles%20and%20a%20drone%20hovering%20over%20green%20crops%2C%20soft%20teal%20and%20emerald%20ambient%20lighting%2C%20gentle%20mist%2C%20high-end%20editorial%20technology%20photography%2C%20dark%20moody%20tones%2C%20plenty%20of%20clean%20negative%20space%20for%20text&width=1920&height=1080&seq=home-hero-agriculture-01&orientation=landscape',
  },
  {
    key: 'logistics',
    title: '智慧物流',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20a%20modern%20smart%20logistics%20warehouse%20at%20night%2C%20robotic%20conveyor%20lines%20and%20neatly%20stacked%20pallets%2C%20electric%20freight%20trucks%20docked%20outside%2C%20glowing%20digital%20tracking%20lines%2C%20cool%20teal%20and%20deep%20navy%20lighting%2C%20light%20mist%2C%20high-end%20industrial%20editorial%20photography%2C%20dark%20moody%20tones%2C%20plenty%20of%20clean%20negative%20space%20for%20text&width=1920&height=1080&seq=home-hero-logistics-01&orientation=landscape',
  },
  {
    key: 'parking',
    title: '智慧停车',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20aerial%20drone%20view%20high%20above%20a%20busy%20city%20road%20intersection%20at%20night%2C%20glowing%20car%20headlights%20and%20long%20amber%20light%20trails%20flowing%20along%20multi-lane%20streets%2C%20zebra%20crossings%20and%20green%20trees%20lining%20the%20roads%2C%20warm%20street%20lamp%20glow%2C%20high-end%20urban%20editorial%20photography%2C%20dark%20moody%20tones%20with%20deep%20shadows%2C%20plenty%20of%20clean%20negative%20space%20for%20text&width=1920&height=1080&seq=home-hero-parking-02&orientation=landscape&nocache=true',
  },
];

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % HERO_SLIDES.length);
    }, SLIDE_INTERVAL);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="absolute inset-0">
      {HERO_SLIDES.map((slide, index) => {
        const isActive = index === active;
        return (
          <div
            key={slide.key}
            className={`absolute inset-0 transition-opacity duration-[1400ms] ease-out ${
              isActive ? 'opacity-100' : 'opacity-0'
            }`}
            aria-hidden={!isActive}
          >
            {slide.image ? (
              <img
                src={slide.image}
                alt={`${slide.title}真实场景应用`}
                title={`${slide.title}真实场景应用`}
                className="h-full w-full object-cover object-center"
              />
            ) : (
              <div className="h-full w-full">
                <HeroShader />
              </div>
            )}
          </div>
        );
      })}

      {/* 深色遮罩：保证文字在任何一张背景上都清晰可读 */}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/62 to-foreground-950/28"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-transparent to-foreground-950/70"></div>

      {/* 轮播指示点 */}
      <div className="absolute bottom-8 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2">
        {HERO_SLIDES.map((slide, index) => (
          <button
            key={slide.key}
            type="button"
            onClick={() => setActive(index)}
            aria-label={`查看${slide.title}`}
            className={`h-1.5 cursor-pointer rounded-full transition-all duration-300 ${
              index === active
                ? 'w-6 bg-accent-400'
                : 'w-1.5 bg-background-50/40 hover:bg-background-50/70'
            }`}
          />
        ))}
      </div>
    </div>
  );
}